import React from "react";
import styled from "styled-components";
import { font } from "../../styles/font";

interface CommonButtonProps {
    text: string;
    enabled?: boolean;
    onClick?: () => void;
    width?: string;
    height?: string;
    className?: string;
}

const CommonButton: React.FC<CommonButtonProps> = ({
    text,
    enabled = true,
    onClick,
    width = "100%",
    height = "56px",
    className
}) => {
    return (
        <StyledButton
            enabled={enabled}
            onClick={enabled ? onClick : undefined}
            style={{ width, height }}
            className={className}
        >
            <ButtonText enabled={enabled}>{text}</ButtonText>
        </StyledButton>
    );
};

const StyledButton = styled.button<{ enabled: boolean }>`
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 16px;
    gap: 8px;
    background: ${(props) => (props.enabled ? "#007F73" : "#E8EEF2")};
    border: 1px solid ${(props) => (props.enabled ? "#007F73" : "#E8EEF2")};
    border-radius: 12px;
    cursor: ${(props) => (props.enabled ? "pointer" : "default")};
`;

const ButtonText = styled.span<{ enabled: boolean }>`
    ${font(700, "clamp(14px, 2.8vw, 18px)", 1.5)}
    text-align: center;
    color: ${(props) => (props.enabled ? "#FFFFFF" : "#A4ADB2")};
`;

export default CommonButton;
